<template>
    <div class="row sub-header-container" v-show="pageHeader!=null"> 
        <div class="col-md-12 col-xs-10">
            <h3 >{{pageHeader}}
            </h3>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name: "AppBarItem",
    computed: {
        ...mapGetters({
            pageHeader: 'pageHeader'
        })
    },
};
</script>



// WEBPACK FOOTER //
// src/components/AppBarItem.vue